import { Map } from "immutable";
import * as ActionTypes from "./../constants/actionTypes.js";

const initialState = Map({
  firstname: "",
  _firstnameError: false,
  lastname: "",
  _lastnameError: false,
  street: "",
  _streetError: false,
  street2: "",
  _street2Error: false,
  city: "",
  _cityError: false,
  state: "",
  _stateError: false,
  zip: "",
  _zipError: false,
  email: "",
  _emailError: false,
  phone: "",
  changePhoneTxt: "",
  _phoneError: false,
  _phoneErrorModal: false,
  twilioVerify: false,
  creditCardNum: "",
  _creditCardNumError: false,
  month: "",
  _monthError: false,
  year: "",
  _yearError: false,
  ccv: "",
  _ccvError: false,
  achNum: "",
  _achNumErr: false,
  routingNum: "",
  _routingNumErr: false,
  acctType: "",
  _acctTypeErr: false,
  mainPaymentError: false,
  bitcoinPaymentId: "",
  acceptTerms: false,
  _acceptTermsError: false,
  token: null,
  signInEmail: null,
  signInPassword: null,
  invalidSignInEmail: false,
  invalidSignInPassword: false,
  forgotPassEmail: null,
  signedIn: false,
  forgotPassword: null,
  orderID: null,
  orderIDShow: null,
  sessionID: null,
  verifyID: null,
  passCode: null,
  accountStatus: "",
  attempts: "0",
  round: 1,
  customTwilioMsg: "",
  showRecaptcha: false,
  recaptchaCode: null,
  showSendAnotherCodeBtn: false,
  mainErrorMsg: "Please correct the errors below and try again.",
  passErrorMsg: "Invalid Password",
  keepAliveError: false,
  showDetailsOrder: true,
  searchTxt: "",
  creditCards: null,
  bankAccounts: null,
  customerBankAccounts: [],
  achAuthorized: false,
  bulkSeller: false,
  ecommerceInfoSent: false,
  creditCardToRemove: null,
  defaultPaymentOption: {},
  _logoutThunkRunning: false,
  _customerInfoThunkRunning: false,
  braintreeToken: "",
  fireRegisterExtole: false,
  paymentOptions: {},
  showAdditionalPaymentOptions: false,
  selectedPaymentOptionId: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_CUSTOM_TWILIO_MSG:
      return state.set("customTwilioMsg", action.payload);

    case ActionTypes.FIRE_EXTOLE_REGISTRATION:
      return state.set("fireRegisterExtole", true);

    case ActionTypes.EXTOLE_REGISTRATION_COMPLETE:
      return state.set("fireRegisterExtole", false);

    case ActionTypes.SEND_ECOMMERCE_INFO:
      return state.set("ecommerceInfoSent", true);

    case ActionTypes.SHOW_DETAILS_ORDER:
      return state.set("showDetailsOrder", true);

    case ActionTypes.HIDE_DETAILS_ORDER:
      return state.set("showDetailsOrder", false);

    case ActionTypes.UPDATE_SEARCH_TEXT:
      return state.set("searchTxt", action.payload);

    case ActionTypes.TOGGLE_DETAILS_ORDER:
      return state.set("showDetailsOrder", !state.get("showDetailsOrder"));

    case ActionTypes.DISPLAY_RECAPTCHA:
      return state.set("showRecaptcha", true);

    case ActionTypes.SET_RECAPTCHA:
      return state.set("recaptchaCode", action.payload);

    case ActionTypes.DISPLAY_CHANGE_PHONE_ERROR:
      return state.set("_phoneErrorModal", true);

    case ActionTypes.HIDE_CHANGE_PHONE_ERROR:
      return state.set("_phoneErrorModal", false);

    case ActionTypes.SET_CHANGE_PHONE_TXT:
      return state.set("changePhoneTxt", action.payload);

    case ActionTypes.UPDATE_ACCOUNT_STATUS:
      return state.set("accountStatus", action.payload);

    case ActionTypes.UPDATE_ATTEMPTS:
      return state.set("attempts", action.payload);

    case ActionTypes.UPDATE_PASS_CODE:
      return state.set("passCode", action.payload);

    case ActionTypes.SET_VERIFY_ID:
      return state.set("verifyID", action.payload);

    case ActionTypes.SHRINK_BOX:
      return state.set("forgotPassword", null);

    case ActionTypes.SET_SESSION_ID:
      return state.set("sessionID", action.payload);

    case ActionTypes.SET_FIRST_NAME:
      return state.set("firstname", action.payload);

    case ActionTypes.SET_LAST_NAME:
      return state.set("lastname", action.payload);

    case ActionTypes.ACCEPT_TERMS:
      return state.set("acceptTerms", true);

    case ActionTypes.DENY_TERMS:
      return state.set("acceptTerms", false);

    case ActionTypes.SET_STREET:
      return state.set("street", action.payload);

    case ActionTypes.SET_CITY:
      return state.set("city", action.payload);

    case ActionTypes.SET_ZIPCODE:
      return state.set("zip", action.payload);

    case ActionTypes.SET_CREDIT_CARD:
      return state.set("creditCardNum", action.payload);

    case ActionTypes.SELECT_MONTH:
      return state.set("month", action.payload);

    case ActionTypes.SELECT_YEAR:
      return state.set("year", action.payload);

    case ActionTypes.SELECT_STATE:
      return state.set("state", action.payload);

    case ActionTypes.SET_PHONE:
      return state.set("phone", action.payload);

    case ActionTypes.SET_EMAIL:
      return state.set("email", action.payload);

    case ActionTypes.SET_CCV:
      return state.set("ccv", action.payload);

    case ActionTypes.SET_TOKEN:
      return state.set("token", action.payload);

    case ActionTypes.SET_SIGNIN_EMAIL:
      return state.set("signInEmail", action.payload);

    case ActionTypes.CLEAR_SET_SIGNIN_EMAIL:
      return state.set("signInEmail", "");

    case ActionTypes.SET_SIGNIN_PASSWORD:
      return state.set("signInPassword", action.payload);

    case ActionTypes.CLEAR_SET_SIGNIN_PASSWORD:
      return state.set("signInPassword", "");

    case ActionTypes.DISPLAY_SIGNIN_EMAIL_ERROR:
      return state.set("invalidSignInEmail", true);

    case ActionTypes.HIDE_SIGNIN_EMAIL_ERROR:
      return state.set("invalidSignInEmail", false);

    case ActionTypes.DISPLAY_SIGNIN_PASS_ERROR:
      return state
        .set("invalidSignInPassword", true)
        .set("passErrorMsg", action.payload);

    case ActionTypes.DISPLAY_FIRST_NAME_ERROR:
      return state.set("_firstnameError", true);

    case ActionTypes.DISPLAY_LAST_NAME_ERROR:
      return state.set("_lastnameError", true);

    case ActionTypes.DISPLAY_STREET_ERROR:
      return state.set("_streetError", true);

    case ActionTypes.DISPLAY_STATE_ERROR:
      return state.set("_stateError", true);

    case ActionTypes.DISPLAY_ZIP_ERROR:
      return state.set("_zipError", true);

    case ActionTypes.DISPLAY_EMAIL_ERROR:
      return state.set("_emailError", true);

    case ActionTypes.DISPLAY_PHONE_ERROR:
      return state.set("_phoneError", true);

    case ActionTypes.DISPLAY_CREDIT_CARD_NUM_ERROR:
      return state.set("_creditCardNumError", true);

    case ActionTypes.DISPLAY_MONTH_ERROR:
      return state.set("_monthError", true);

    case ActionTypes.DISPLAY_YEAR_ERROR:
      return state.set("_yearError", true);

    case ActionTypes.DISPLAY_CCV_ERROR:
      return state.set("_ccvError", true);

    case ActionTypes.DISPLAY_CITY_ERROR:
      return state.set("_cityError", true);

    case ActionTypes.HIDE_CITY_ERROR:
      return state.set("_cityError", false);

    case ActionTypes.HIDE_FIRST_NAME_ERROR:
      return state.set("_firstnameError", false);

    case ActionTypes.HIDE_LAST_NAME_ERROR:
      return state.set("_lastnameError", false);

    case ActionTypes.HIDE_SIGNIN_PASS_ERROR:
      return state.set("invalidSignInPassword", false);

    case ActionTypes.HIDE_STREET_ERROR:
      return state.set("_streetError", false);

    case ActionTypes.HIDE_STATE_ERROR:
      return state.set("_stateError", false);

    case ActionTypes.HIDE_ZIP_ERROR:
      return state.set("_zipError", false);

    case ActionTypes.HIDE_EMAIL_ERROR:
      return state.set("_emailError", false);

    case ActionTypes.HIDE_PHONE_ERROR:
      return state.set("_phoneError", false);

    case ActionTypes.HIDE_CREDIT_CARD_NUM_ERROR:
      return state.set("_creditCardNumError", false);

    case ActionTypes.HIDE_MONTH_ERROR:
      return state.set("_monthError", false);

    case ActionTypes.HIDE_YEAR_ERROR:
      return state.set("_yearError", false);

    case ActionTypes.HIDE_CCV_ERROR:
      return state.set("_ccvError", false);

    case ActionTypes.HIDE_ACH_ACCOUNT_NUM_ERROR:
      return state.set("_achNumErr", false);

    case ActionTypes.HIDE_ACH_ROUTING_NUM_ERROR:
      return state.set("_routingNumErr", false);

    case ActionTypes.HIDE_ACH_ACCOUNT_TYPE_ERROR:
      return state.set("_acctTypeErr", false);

    case ActionTypes.DISPLAY_MAIN_PAYMENT_ERROR:
      return state
        .set("mainPaymentError", true)
        .set("keepAliveError", true)
        .set("mainErrorMsg", action.payload);

    case ActionTypes.DISPLAY_ACCEPT_TERMS_ERROR:
      return state.set("_acceptTermsError", true);

    case ActionTypes.HIDE_ACCEPT_TERMS_ERROR:
      return state.set("_acceptTermsError", false);

    case ActionTypes.HIDE_MAIN_PAYMENT_ERROR:
      return state.set("mainPaymentError", false);

    case ActionTypes.SET_FORGOT_PASS_EMAIL:
      return state.set("forgotPassEmail", action.payload);

    case ActionTypes.SET_ACH_SELL_ACCOUNT_NUM:
      return state.set("achNum", action.payload);

    case ActionTypes.SET_ACH_SELL_ROUTING_NUM:
      return state.set("routingNum", action.payload);

    case ActionTypes.SET_ACH_SELL_ACCOUNT_TYPE:
      return state.set("acctType", action.payload);

    case ActionTypes.RESET_SELL_ACH:
      return state
        .set("achId", null)
        .set("achNum", "")
        .set("routingNum", "")
        .set("acctType", "");

    case ActionTypes.UPDATE_SAVE_ACH_SELL:
      return state
        .set("achId", action.payload.id)
        .set("achNum", action.payload.accountNumber)
        .set("routingNum", action.payload.routingNumber)
        .set("acctType", action.payload.accountType);

    case ActionTypes.SET_ORDER_ID:
      return state.set("orderID", action.payload.id);

    case ActionTypes.UPDATE_PAYPAL_SELL_INFO:
      return state
        .set("internalPaymentId", action.payload.internalPaymentId)
        .set("paymentId", action.payload.paymentId);

    case ActionTypes.DISPLAY_CUSTOMER_INFO_ERRORS:
      return state
        .set("_firstnameError", action.payload._firstNameErr)
        .set("_lastnameError", action.payload._lastNameErr)
        .set("_streetError", action.payload._streetErr)
        .set("_phoneError", action.payload._phoneErr)
        .set("_zipError", action.payload._zipErr)
        .set("_cityError", action.payload._cityErr)
        .set("_stateError", action.payload._stateErr)
        .set("_creditCardNumError", action.payload._creditCardNumErr)
        .set("_acceptTermsError", action.payload._acceptTermsErr)
        .set("_emailError", action.payload._emailErr)
        .set("_monthError", action.payload._monthErr)
        .set("_yearError", action.payload._yearErr)
        .set("_achNumErr", action.payload._achNumErr)
        .set("_routingNumErr", action.payload._routingNumErr)
        .set("_acctTypeErr", action.payload._acctTypeErr)
        .set("_ccvError", action.payload._ccvErr);

    case ActionTypes.SET_CREDIT_CARD_TO_REMOVE:
      return state.set("creditCardToRemove", action.payload);

    case ActionTypes.SET_CUSTOMER_PROFILE:
      const { profileData } = action.payload;

      return state
        .set("id", profileData.customer.id)
        .set("firstname", profileData.customer.firstname)
        .set("lastname", profileData.customer.lastname)
        .set("email", profileData.customer.email)
        .set("phone", profileData.customer.phone[0].number.toString())
        .set("twilioVerify", profileData.customer.twillioVerify) // CAUTION returned property has too many L's
        .set("state", profileData.customer.address[0].state)
        .set("city", profileData.customer.address[0].city)
        .set("zip", profileData.customer.address[0].postcode)
        .set("street", profileData.customer.address[0].street)
        .set("street2", profileData.customer.address[0].street2)
        .set("signedIn", true)
        .set("creditCards", profileData.customer.creditCards)
        .set("bankAccounts", profileData.customer.bankAccounts)
        .set("achAuthorized", profileData.customer.achAuthorized)
        .set("bulkSeller", profileData.customer.bulkSeller)
        .set(
          "defaultPaymentOption",
          profileData.customer.defaultPaymentOption.sell
        )
        .set("_firstnameError", false)
        .set("_lastnameError", false)
        .set("_emailError", false)
        .set("_phoneError", false)
        .set("_stateError", false)
        .set("_cityError", false)
        .set("_zipError", false)
        .set("_streetError", false);

    case ActionTypes.CUSTOMER_PROFILE_THUNK_RUNNING:
      return state.set("_customerInfoThunkRunning", action.payload);

    case ActionTypes.LOGOUT:
      return state
        .set("signedIn", false)
        .set("creditCards", null)
        .set("firstname", "")
        .set("lastname", "")
        .set("email", "")
        .set("phone", "")
        .set("twilioVerify", "")
        .set("state", "")
        .set("city", "")
        .set("zip", "")
        .set("street", "");

    case ActionTypes.LOGOUT_MARK_THUNK_RUNNING:
      return state.set("_logoutThunkRunning", true);

    case ActionTypes.LOGOUT_CLEAR_THUNK_RUNNING:
      return state.set("_logoutThunkRunning", false);

    case ActionTypes.RESET:
      return initialState;

    case ActionTypes.RESET_EXPIRE:
      return initialState;

    case ActionTypes.SET_PAYMENT_OPTIONS:
      return state.set("paymentOptions", action.payload);

    case ActionTypes.SHOW_ADDITIONAL_PAYMENT_OPTIONS:
      return state.set("showAdditionalPaymentOptions", true);

    case ActionTypes.HIDE_ADDITIONAL_PAYMENT_OPTIONS:
      return state
        .set("showAdditionalPaymentOptions", false)
        .set("selectedPaymentOptionId", null);

    case ActionTypes.SELECT_PAYMENT_OPTION:
      return state.set("selectedPaymentOptionId", action.payload);

    case ActionTypes.SET_CUSTOMER_BANK_ACCOUNTS:
      return state.set("customerBankAccounts", action.payload);

    default:
      return state;
  }
};
